import React from 'react'

import { Suspense } from '~/components/elements/Suspense'
import { useBrandAccountQuery } from '~/hooks/useBrandAccountQuery'
import { useLogEventOnMount } from '~/hooks/useLogEventOnMount'

import { StrategyMemoEdit } from './components/StrategyMemoEdit'
import { useMainQuery } from './hooks/useMainQuery'

export const StrategyMemoEditPage = () => {
  const { isLoading: isBrandAccountQueryLoading } = useBrandAccountQuery()
  const { isLoading: isMainQueryLoading } = useMainQuery()

  useLogEventOnMount('Access to each customer strategy')

  return (
    <Suspense loading={isBrandAccountQueryLoading || isMainQueryLoading}>
      <StrategyMemoEdit />
    </Suspense>
  )
}
